import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PersonalFormState {
  name: string;
  display_name: string;
  national_id: string;
  address: string;
  postal_code: string;
  phone: string;
  identity_type: string;
  id?: number; 
}

const initialState: PersonalFormState = {
  name: '',
  display_name: '',
  national_id: '',
  address: '',
  postal_code: '',
  phone: '',
  identity_type: 'PERSONAL',
};

const personalFormSlice = createSlice({
  name: 'personalForm',
  initialState,
  reducers: {
    updatePersonalForm(state, action: PayloadAction<{ [key: string]: string }>) {
      Object.keys(action.payload).forEach((key) => {
        (state as any)[key] = action.payload[key];
      });
    },
    setId(state, action: PayloadAction<number>) {
      state.id = action.payload;
    },
  },
});

export const { updatePersonalForm, setId } = personalFormSlice.actions;
export default personalFormSlice.reducer;
